import gsap from 'gsap';

export const firstEnterElement = {
  data() {
    return {
			flag: true,
			margin: ""
    }
	},
  methods: {
		chooseMargin() {
			const currentRoute = this.$router.currentRoute.name;
			let mobile = window.matchMedia('(max-width: 519px)');
			let tablet = window.matchMedia('(max-width: 979px)');
			let desktop = window.matchMedia('(min-width: 980px)');

			if(currentRoute == "slider") {
				if(mobile.matches) {
					this.margin = "0px 0px 70px 0px"
				} else if (!mobile.matches && tablet.matches) {
					this.margin = "0px 0px 150px 0px"
				} else if (desktop.matches) {
					this.margin = "0px 0px 220px 0px"
				}
			} else if (currentRoute == "brands") {
				if(mobile.matches) {
					this.margin = "0px 0px 60px 0px"
				} else if (!mobile.matches && tablet.matches) {
					this.margin = "0px 0px 100px 0px"
				} else if (desktop.matches) {
					this.margin = "0px 0px 150px 0px"
				}
			}
		},
		open(el) {
			this.chooseMargin()
			gsap.set(el, {y: 250, opacity: 0})
			let options = {
				root: null,
				rootMargin: this.margin,
				threshold: 0
			}

			let observer = new IntersectionObserver((entries) => {
				entries.forEach(enter => {
					if(enter.intersectionRatio > 0 && enter.boundingClientRect.y > 0 && this.flag) {
						this.flag = false
						gsap.to([enter.target], 1, {y: 0, opacity: 1, stagger: 0.1, onComplete: () =>{
							gsap.set(enter.target, {clearProps:'all'});
						}})
					}
				})
			}, options);

			observer.observe(el)
		}
	}
}